<template>
  <div class="home">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card" v-for="(data, index) in items" :key="index">
            <template v-if="data.length">
              <h4 class="card-header">{{ titleCase(index) }}</h4>
              <div class="list-group list-group-flush" v-for="(item, index) in data" :key="index">
                <router-link :to="{ path: item.path, append: true }" class="list-group-item list-group-item-action">
                  {{ item.name }}
                </router-link>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {
    OPEN_ERROR_MODAL,
    LOAD_DATABASE_MANAGER_LIST
  } from '@/vuex/types'
  import _ from 'lodash'
  export default {
    name: 'DatabaseList',
    computed: {
      ...mapGetters([
        'databaseManager'
      ]),
      items () {
        return this.databaseManager(this.$user)
      }
    },
    async mounted () {
      try {
        await this.$store.dispatch(LOAD_DATABASE_MANAGER_LIST)
      } catch (err) {
        this.$store.dispatch(OPEN_ERROR_MODAL, err)
      }
    },
    methods: {
      titleCase (str) {
        return _.startCase(str)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/DatabaseManager.vue